import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import "@/i18n";
import App from "@/App";
import { ThemeProvider } from "@/context/ThemeContext";
import { TierProvider } from "@/components/EnterpriseGate";
import { AuthProvider } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import { initTelemetry } from "@/lib/telemetry";

// Boot telemetry before React mounts so breadcrumbs catch early errors.
initTelemetry();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ThemeProvider>
      <AuthProvider>
        <TierProvider>
          <App />
          <Toaster richColors position="top-right" />
        </TierProvider>
      </AuthProvider>
    </ThemeProvider>
  </React.StrictMode>,
);
